/** @jsx jsx */
import React from "react";
import { jsx } from "theme-ui";

// Pattern Example - (YOUR_TEXT)[#HEX_CODE]
export const REGEX_PATTERN_FOR_ADDING_COLOR_TO_MARKUP = /\(([^\)]+)\)(?=\[(#\w+)\])/;
export const REGEX_HEX_CODE = /\[#(([0-9a-fA-F]{2}){3}|([0-9a-fA-F]){3})\]/;
// Todo - support for multiple color sub text
const addColor = (text) => {
  const content = text.split(REGEX_PATTERN_FOR_ADDING_COLOR_TO_MARKUP);
  if (content.length > 1) {
    const initialText = content[0];
    const colouredText = content[1];
    const colorCode = content[2];
    const endingText = content[3].replace(REGEX_HEX_CODE, "");
    return <>
      {initialText}
      <span sx={{ color: colorCode }}>{colouredText}</span>
      {endingText}
    </>;
  }
  return text;
};

const EnhanceMarkup = ({ text }) => (
  <>
    {addColor(text)}
  </>
);

export default EnhanceMarkup;
